import Vue from 'vue';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import axios from 'axios';

Vue.use(VueI18Next);

const language = localStorage.getItem('lang') || 'en';

i18next.init({
  lng: language,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
    defaultVariables: {
      brand: process.env.BRAND_CONFIG.name,
    },
  },
  resources: {},
});

function loadLanguage(lang) {
  if (i18next.hasResourceBundle(lang, 'translation')) {
    return;
  }

  axios(`/locales/${lang}.json?v${process.env.PACKAGE_VERSION}`).then((response) => {
    i18next.addResourceBundle(lang, 'translation', response.data);
  });
}

if (language !== 'en') {
  loadLanguage('en');
}

loadLanguage(language);

i18next.on('languageChanged', loadLanguage);

Vue.prototype.$jt = function (json) {
  // TODO add reactivity

  try {
    const message = JSON.parse(json);
    const currentLanguage = this.$i18n.i18next.language;
    const fallbackLanguage = this.$i18n.i18next.options.fallbackLng[0];
    return message[currentLanguage] || message[fallbackLanguage];
  } catch {
    return json;
  }
};

// Add a global $t method to Vue.prototype for plugins to use
Vue.prototype.$t = function (key, options) {
  return i18next.t(key, options);
};

export function waitForTranslation() {
  if (i18next.hasResourceBundle(i18next.language, 'translation')) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const onLanguageAdded = (addedLanguage) => {
      if (addedLanguage !== i18next.language) {
        return;
      }

      resolve();
      i18next.store.off('added', onLanguageAdded);
    };

    i18next.store.on('added', onLanguageAdded);
  });
}
export const vuei18n = new VueI18Next(i18next);
export const i18n = i18next;
